import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Inquiry } from 'dashboard/models/inquiry';
import { Report } from 'dashboard/models/report';
import { Verification } from 'dashboard/models/verification';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiResponse } from 'lib/interfaces/api';

export const accountApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    getInquiryObjectById: builder.query<ApiResponse<Inquiry>, { id: string; inquiryId: string }>({
      query: async ({ id, inquiryId }) =>
        await SessionClientDashboard.get<Inquiry>(
          ApiEndpoint.Account,
          id,
          `inquiry-object?inquiry-id=${inquiryId}`,
        ),
    }),
    getReportObjectById: builder.query<ApiResponse<Report>, { id: string; reportId: string }>({
      query: async ({ id, reportId }) =>
        await SessionClientDashboard.get<Report>(
          ApiEndpoint.Account,
          id,
          `report-object?report-id=${reportId}`,
        ),
    }),
    getVerificationObjectById: builder.query<
      ApiResponse<Verification>,
      { id: string; verificationId: string }
    >({
      query: async ({ id, verificationId }) =>
        await SessionClientDashboard.get<Verification>(
          ApiEndpoint.Account,
          id,
          `verification-object?verification-id=${verificationId}`,
        ),
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const {
  useGetInquiryObjectByIdQuery,
  useGetReportObjectByIdQuery,
  useGetVerificationObjectByIdQuery,
} = accountApi;
